<template>
  <div class="position-relative mb-1">
    <div class="input-sizer">
      <span :class="['spacer', 'form-control', {'all-emoji': isJustEmoji}]" contenteditable="true"><br>{{ value }}</span>
      <textarea
        ref="textarea"
        name="message"
        aria-label="Message"
        :value="value"
        cols="30"
        :class="['form-control', {'all-emoji': isJustEmoji}]"
        :disabled="disabled"
        @input="updateValue($event.target.value)"
        @keyup="updateTrigger"
      />
    </div>
    <span v-if="!disabled && hasButtons" class="button-group border rounded-pill">
      <CannedResponsePicker
        v-if="cannedResponses"
        :canned-responses="cannedResponses"
        :textarea="box"
        :trigger="trigger"
        @input="updateValue"
        @cancelTrigger="cancelTrigger"
      />
      <UploaderWrapper
        v-if="showUploadButton"
        :token-url="tokenUrl"
        @update:imageName="$emit('update:imageName', $event)"
        @update:imagePath="$emit('update:imagePath', $event)"
      >
        <InputButton
          class="image-upload-invoker"
          icon="image"
          label="Upload image"
        />
      </UploaderWrapper>
      <EmojiPicker
        v-if="showEmojiButton"
        :textarea="box"
        @input="updateValue"
        @cancelTrigger="cancelTrigger"
      />
      <InputButton
        v-if="showDeleteButton"
        :danger="true"
        icon="trash-alt"
        label="Delete"
        @click="deleteMessage"
      />
    </span>
  </div>
</template>
<script>
import EmojiPicker from '@/FormWidgets/WidgetInputArea/components/EmojiPicker.vue'
import {isJustEmoji} from '@/Inbox/helpers/emojiHelper'
import InputButton from "@/FormWidgets/WidgetInputArea/components/InputButton.vue";
import CannedResponsePicker from "@/FormWidgets/WidgetInputArea/components/CannedResponsePicker.vue";
import UploaderWrapper from "@/FormWidgets/UploaderWrapper/UploaderWrapper.vue";

export default {
  name: 'InputArea',
  // Vue 3:
  // emits: ['input', 'update:imageName', 'update:imagePath'],
  components: {
    UploaderWrapper,
    CannedResponsePicker,
    InputButton,
    EmojiPicker,
  },
  props: {
    cannedResponses: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      required: true
    },
    /** Whether to show the emoji picker button */
    showEmojiButton: {
      type: Boolean,
      default: true,
    },
    /** Whether to show the delete button */
    showDeleteButton: {
      type: Boolean,
      default: false,
    },
    /** The URL to upload to, if uploading is available */
    tokenUrl: {
      type: String,
      required: false,
    },
    imageName: {
      type: String,
      default: "",
    },
    imagePath: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      isJustEmoji: false,
      trigger: null, // must not be under provide/inject to be reactive
      uploaderOpen: false,
      height: 100,
    }
  },
  computed: {
    hasButtons() {
      // Image upload can be disabled with a blank tokenUrl, or by uploading an image
      return this.showUploadButton || this.showEmojiButton || this.showDeleteButton || this.cannedResponses;
    },
    // Note: When an image is successfully uploaded, this technically closes the uploader twice:
    // once from `closeAfterFinish: true` in the constructor and once by the onDestroy of UploadWrapper
    showUploadButton() {
      return this.tokenUrl &&  this.imagePath === '';
    }
  },
  watch: {
    value: {
      handler: function(newVal) {
        this.changeTextareaFontSize(newVal);
      },
      immediate: true
    },
  },
  methods: {
    box() {
      return this.$refs.textarea;
    },
    updateValue(text) {
      this.$emit('input', text);
    },
    cancelTrigger(refocus) {
      this.updateTrigger(false);
      if(refocus) {
        this.$refs.textarea.focus();
      }
    },
    updateTrigger(event) {
      this.trigger = event;
    },
    changeTextareaFontSize(newVal) {
      this.isJustEmoji = isJustEmoji(newVal);
    },
    deleteMessage() {
      this.$emit('delete');
    },
  },
}
</script>

<style scoped>

div {
  /** todo: properly scope event-logic.scss and remove */
  margin-top: 0 !important;
}

.input-sizer {
  position: relative;
  width: 100%;

  /* Use a textarea for input, but hide a span (.spacer) behind it with the same content to take up the appropriate space on
     the page, thus giving the impression that the textarea is being resized to its own content (not really possible portably) */
  .spacer,
  textarea {
    /* Approximately 3 buttons plus their padding: */
    min-height: calc(1.5 * 3rem + 2 * 0.75rem);
    width: 100%;
    /* Approximately 1 button plus its padding: */
    padding-right: 2rem;
    height: 100%;
    max-width: 100%;
    resize: none;
    white-space: pre-wrap;
  }
  .spacer {
    margin-top: 1em;
    visibility: hidden;
  }
  textarea{
    top: 0;
    position: absolute;
  }
}

/* Set by methods.changeTextareaFontSize */
.all-emoji {
  font-size: 1.8rem;
}

.button-group {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  display: flex;
  /* Minimize right padding needed to keep text off buttons: */
  flex-direction: column;
}

</style>